import { createAction, props } from '@ngrx/store';

import { EnrichmentData, ItemCategory } from './enriched-watchlist.models';

import { WatchlistItem } from '../watchlist/watchlist.models';

export const openPage = createAction(
  '[EnrichedWatchlist Page] Open EnrichedWatchlist Page',
  props<{ page: number; itemCategory?: ItemCategory }>()
);

export const init = createAction(
  '[EnrichedWatchlist API] Init EnrichedWatchlist',
  props<{ page: number; itemCategory: ItemCategory }>()
);

export const setItemCategory = createAction(
  '[EnrichedWatchlist API] Set EntityType on EnrichedWatchlist',
  props<{ itemCategory: ItemCategory }>()
);

export const setPageCount = createAction(
  '[EnrichedWatchlist API] Set virtual maximum page count for EnrichedWatchlist',
  props<{ pageCount: number }>()
);

export const loadItems = createAction(
  '[EnrichedWatchlist API] Load items on EnrichedWatchlist',
  props<{ items: WatchlistItem[] }>()
);

export const loadSuccess = createAction(
  '[EnrichedWatchlist/API] Load EnrichedWatchlist Success',
  props<{ enrichedItems: EnrichmentData[] }>()
);

export const loadError = createAction(
  '[EnrichedWatchlist/API] Load EnrichedWatchlist Success',
  props<{ error: any }>()
);
